import { Link } from "react-router-dom";

import logo from "../../assets/logos/logo.webp";

export const Header = () => {
    return (
        <header className="header-general">
            <Link to="/">
                <img
                    className="icon-home"
                    width="350"
                    height="auto"
                    src={logo}
                    alt="Logo de Talento Konecta"
                />
            </Link>
        </header>
    );
};
